<template>

  <el-row >
    <el-form :model="ruleData" ref="ApprovalRuleChangeForm" :rules="rules"  label-width="220px" class="ApprovalRuleChangeForm" >
      <el-col>
        <h2>Approval Rule</h2>
        <el-row :gutter="20">
          <el-col :lg="6">
            Rule ID:  {{ruleData.id}}
          </el-col>
        </el-row>
        <hr />
        <el-row :gutter="24">
          <el-col :lg="7">
            <el-form-item label="Level" prop="level">
              <el-input-number v-model="ruleData.level" :min="1.0" :max="10.9" :step=".1" :disabled="disabled"></el-input-number>
            </el-form-item>
          </el-col>
          <el-col :lg="1">
            <tool-tip-popup text="Note: The level determines the order in which approvers are notified.  Approvers are notified in order from lowest to highest level."></tool-tip-popup>
          </el-col>
          <el-col :lg="5" :md="0"><div>&nbsp;</div></el-col>
          <el-col :lg="6">
            <el-form-item label="Active" prop="isActive">
              <el-checkbox v-model="ruleData.isActive" :disabled="disabled"></el-checkbox>
            </el-form-item>
          </el-col>
          <el-col :lg="1">
            <tool-tip-popup text="Note: Determines if this rule is active or ignored when determining approvals."></tool-tip-popup>
          </el-col>
        </el-row>

        <el-row :gutter="24">
          <el-col :lg="12">
            <el-form-item label="Description" prop="ruleDescription">
              <el-input v-model="ruleData.ruleDescription" type="textarea" :minlength="3" :maxlength="200" :autosize="{ minRows: 2, maxRows: 4}" :disabled="disabled"></el-input>
            </el-form-item>
          </el-col>
          <el-col :lg="1" :md="0"><div>&nbsp;</div></el-col>
          <el-col :lg="9">
            <el-form-item label="Approval Role" prop="assignToPEARoleId">
              <role-dropdown v-model="ruleData.assignToPEARoleId" :inputModel="ruleData.assignToPEARoleId" :disabled="disabled"></role-dropdown>
            </el-form-item>
          </el-col>
          <el-col :lg="1">
            <tool-tip-popup text="Note: Approver Role assigned to a PEA if the PEA evaluates to true for this rule."></tool-tip-popup>
          </el-col>
        </el-row>
        <!--<el-row :gutter="24">
          <el-col :lg="12">
            <el-form-item label="Approval Role" prop="assignToPEARoleId">
              <role-dropdown v-model="ruleData.assignToPEARoleId" :inputModel="ruleData.assignToPEARoleId" :disabled="disabled"></role-dropdown>
            </el-form-item>
          </el-col>
          <el-col :lg="1">
            <tool-tip-popup text="Note: Approver Role assigned to a PEA if the PEA evaluates to true for this rule."></tool-tip-popup>
          </el-col>
        </el-row>-->
        <el-row :gutter="24">
          <el-col :lg="12">
            <el-form-item label="Cost Greater Than" prop="greaterThanNet">
              <currency-input v-model="ruleData.greaterThanNet" :clearable="clearable" :disabled="disabled"></currency-input>
            </el-form-item>
          </el-col>
          <el-col :lg="1">
            <tool-tip-popup text="Note: Any PEA amount greater than or equal to this value is evaluated against this rule."></tool-tip-popup>
          </el-col>
          <el-col :lg="9">
            <el-form-item label="Cost Less Than" prop="lessThanNet">
              <currency-input v-model="ruleData.lessThanNet" :clearable="clearable" :disabled="disabled"></currency-input>
            </el-form-item>
          </el-col>
          <el-col :lg="1">
            <tool-tip-popup text="Note: Any PEA amount less than or equal to this value is evaluated against this rule."></tool-tip-popup>
          </el-col>
        </el-row>
        <!--<el-row :gutter="24">
          <el-col :lg="12">
            <el-form-item label="Cost Less Than" prop="lessThanNet">
              <currency-input v-model="ruleData.lessThanNet" :clearable="clearable" :disabled="disabled"></currency-input>
            </el-form-item>
          </el-col>
          <el-col :lg="1">
            <tool-tip-popup text="Note: Any PEA amount less than or equal to this value is evaluated against this rule."></tool-tip-popup>
          </el-col>
        </el-row>-->
        <el-row :gutter="24">
          <el-col :lg="12">
            <el-form-item label="Division" prop="peaDivisionIds">
              <rule-division-dropdown v-model="ruleData.peaDivisionIds" :multiple="true" :inputModel="ruleData.peaDivisionIds" :disabled="disabled"></rule-division-dropdown>
            </el-form-item>
          </el-col>
          <el-col :lg="1" :md="0"><div>&nbsp;</div></el-col>
          <el-col :lg="11">
            <el-form-item label="Asset Classification" prop="peaFinancialAssetClassificationIds">
              <rule-asset-classification v-model="ruleData.peaFinancialAssetClassificationIds" :multiple="true" :inputModel="ruleData.peaFinancialAssetClassificationIds" :disabled="disabled"></rule-asset-classification>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col>
            <el-alert v-if="alertTitle !== ''"
                      :title="alertTitle"
                      :type="alertType"
                      :description="callInfo"
                      :closable="false"
                      show-icon>
            </el-alert>
          </el-col>
        </el-row>
      </el-col>
</el-form>
    <div v-if="this.creating == false">
      <button class="btn btn-primary" @click="updateApprovalRule()" :disabled="disabled">Update Approval Rule</button>
      </div>
</el-row>
</template>
<script>
import helperMethods from '@/components/utility/helperMethods.js'
export default {
  name: 'changeApprovalRule',
  props: {
    ruleId: {
      default: 0
    },
    disabled: {
      default: false
    },
    creating: {
      default: false
    }
  },
  data () {
    var validateLevelSize = (rule, value, callback) => {
      if (value >= 10.9) {
        callback(new Error('Must be less than 10.9'))
      }
      callback()
    }
    var validateMoneySize = (rule, value, callback) => {
      if (value >= 99999999999.99) {
        callback(new Error('Must be less than $99,999,999,999.99'))
      }
      callback()
    }
    return {
      userName: '',
      isLoading: false,
      alertType: '',
      alertTitle: '',
      callInfo: '',
      clearable: true,
      ruleData: {
        id: 0,
        ruleDescription: '',
        level: '',
        assignToPEARoleId: '',
        isActive: true,
        peaFinancialAssetClassificationIds: [],
        greaterThanNet: null,
        lessThanNet: null,
        peaDivisionIds: []
      },
      divisionList: Array,
      rules: {
        level: [
          { required: true, message: 'Please enter a level', trigger: 'blur' },
          { validator: validateLevelSize, trigger: 'blur' }
        ],
        ruleDescription: [
          { required: true, message: 'Please enter a description', trigger: 'blur' },
          { min: 3, max: 200, message: 'Length should be 3 to 200 characters', trigger: 'blur' }
        ],
        peaDivisionIds: [
          { type: 'array', required: true, message: 'Please enter at least one division', trigger: 'visible-change' }
        ],
        peaFinancialAssetClassificationIds: [
          { type: 'array', required: true, message: 'Please enter at least one financial asset classification', trigger: 'visible-change' }
        ],
        assignToPEARoleId: [
          { type: 'number', required: true, message: 'Please pick an Approval Role', trigger: 'visible-change' }
        ],
        greaterThanNet: [
          { validator: validateMoneySize, trigger: 'blur' }
        ],
        lessThanNet: [
          { validator: validateMoneySize, trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    fetchData () {
      var call = '/getPEARule/' + this.ruleId
      this.$axios.get(call).then(response => {
        this.ruleData = response.data
      })
    },
    formSubmit () {
      // eslint-disable-next-line
      if (this.ruleId <= 0) {
        return this.addApprovalRule()
      } else {
        return this.updateApprovalRule()
      }
    },
    checkIfValid () {
      this.$refs['ApprovalRuleChangeForm'].validate((valid) => {
        if (valid) {
          this.$parent.$emit('createRuleValidation', true)
        } else {
          this.$parent.$emit('createRuleValidation', false)
          helperMethods.showNotification(this.$parent, 'Invalid approval rule requirements', 'Please check approval rule section for invalid inputs.', 'warning', 30000, 'Please check form for invalid inputs.')
        }
      })
    },
    startUp () {
      if (this.$store.getters.isAdmin) {
        // eslint-disable-next-line
        if (this.ruleId !== 0) {
          this.fetchData()
        }
      } else {
        this.disabled = true
      }
    },
    addApprovalRule () {
      var call = '/createPEAApprovalRule'
      // this.peaCore.createdByUserId = this.$store.getters.userId
      return new Promise((resolve, reject) => {
        this.$axios.post(call, this.ruleData).then(response => {
          this.ruleData.id = response.data.id
          // this.peaCore.peaStatus = response.body.peaStatus
          resolve(response)
        })
          .catch(response => {
            reject(response)
          })
      })
    },
    updateApprovalRule () {
      this.$refs['ApprovalRuleChangeForm'].validate((valid) => {
        if (valid) {
          var call = '/updatePEAApprovalRule/' + this.ruleId
          this.$axios.post(call, this.ruleData).then(response => {
            //  debugger
            this.isLoading = false
            if (this.ruleId !== 0) {
              this.fetchData()
            }
            helperMethods.showNotification(this, 'PEA Approval Rule successfully updated', 'PEA Approval Rule Update', 'success', 10000)
          })
            .catch(response => {
              helperMethods.showNotification(this, 'Error updating PEA Approval Rule Information', response, 'error', 30000)
            // helperMethods.showNotification(this.$parent, 'Invalid Comment', 'Please add Comment text', 'warning', 10000, '')
            })
        }
      })
    }
  },
  mounted () {
    this.startUp()
  },
  watch: {
    // watch for route change - going from rule/4 to rule/0
    '$route': 'startUp'
  }
}
</script>
